import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';

export default {
  fetch() {
    Dispatcher.dispatch({
      actionType: ActionTypes.LANGUAGE_STORE_FETCH,
    });
  }
}
